<!-- Undo arrow; isRedo mirrors it. Same 16px stroke style as the toolbar's link icon. -->

<template>
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :style="isRedo ? {transform: 'scaleX(-1)'} : null"
    aria-hidden="true">
    <path d="M9 14 4 9l5-5" />
    <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
  </svg>
</template>

<script setup>
defineProps({isRedo: {type: Boolean, default: false}});
</script>
